import Support from "./Support";
import ViewMoreSupport from "./ViewMoreSupport";
import CreateSupport from "./CreateSupport";

export {
    Support,
    ViewMoreSupport,
    CreateSupport,
}